module.exports = __webpack_public_path__ + "static/tracer-dao-black-7a9d8193b50b23b5024d3914875ca229.png";